<template>
    <restaurant-locations-section
        class="area-restaurants-list-section-module"
        :restaurants="restaurants"
    />
</template>

<script>
    import RestaurantLocationsSection from '../../../organisms/RestaurantLocationsSection/RestaurantLocationsSection';

    export default {
        name: 'area-restaurants-list-section-module',

        components: { RestaurantLocationsSection },

        props: {
            attributes: {
                type: Object,
                required: true,
                default: () => ({}),
            },
        },

        computed: {
            /**
             * Format restaurants data.
             *
             * @returns {Array}
             */
            restaurants() {
                return (this.attributes.location_area?.restaurants || []).map((restaurant) => {
                    return {
                        title: restaurant.name,
                        address: restaurant.address,
                        to: restaurant.page?.uri || '',
                    };
                });
            },
        },
    };
</script>
